import CheckBoxComponent from './containers/checkBoxComponent'

export { default as CheckBoxLayout } from './components/checkBoxLayout' 

export default CheckBoxComponent